import { PropsWithChildren } from 'react'
import { Link } from 'react-router'

import { createStyles } from 'antd-style'
import { isFunction } from 'lodash'

import { RouterLinkProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  link: {
    [`&:hover`]: {
      color: token.colorLinkHover,
      [`&.hover-underline`]: {
        textDecoration: 'underline dashed'
      }
    },
    [`&:active`]: {
      color: token.colorLinkActive
    }
  },
  defaultLink: {
    color: token.colorLink
  },
  textLink: {
    color: token.colorText
  }
}))

const resolveTo = (to: RouterLinkProps['to']) => {
  if (isFunction(to)) {
    return to()
  }
  return to
}

export const RouterLink = ({
  type = 'default',
  hoverUnderline = true,
  newtab = false,
  to,
  className,
  ...linkProps
}: PropsWithChildren<RouterLinkProps>) => {
  const { cx, styles } = useStyles()

  return (
    <Link
      {...linkProps}
      target={newtab ? '_blank' : '_self'}
      to={resolveTo(to) || ''}
      className={cx(
        styles.link,
        {
          ['hover-underline']: hoverUnderline,
          [styles.defaultLink]: type === 'default',
          [styles.textLink]: type === 'text'
        },
        className
      )}
    />
  )
}
